

















































import { Component, Vue } from 'vue-property-decorator';
import { ShippingInfoData, ShippingMethod, Totals } from '@/store/models';
import checkout from '@/store/modules/checkout';
import cart from '@/store/modules/cart';
import { decode as decodeShipment, encode as encodeShipment } from '@/commons/shipmentMethodHelpers';
import store from '@/store';

Component.registerHooks(['mounted']);

@Component({
    components: {},
})
export default class ShippingMethodSelection extends Vue {
    get selectedShipment(): string {
        return checkout.selectedShipment;
    }

    set selectedShipment(value: string) {
        const data: ShippingInfoData = {
            address: checkout.defaultShippingAddress,
            shippingmethod: decodeShipment(value),
        };
        checkout.setSelectedShipment(value);
        cart.flagLoading({ key: 'shipMethods', value: true });
        checkout
            .setShippingInfo(data)
            .then(() => {
                checkout
                    .getPaymentMethods(
                        checkout.billingSameAsShipping ? checkout.shippingAddress : checkout.billingAddress,
                        checkout.shippingAddress,
                    )
                    .finally(() => {
                        cart.flagLoading({ key: 'shipMethods', value: false });
                });
            })
            .catch(() => {
                cart.flagLoading({ key: 'shipMethods', value: false });
            });
    }

    get selectedCountry(): string {
        return checkout.selectedCountry;
    }

    set selectedCountry(value: string) {
        checkout.setSelectedCountry(value);

        if (!value) {
            this.selectedShipment = '';
        }
    }

    get isShippingMethodsLoading(): boolean {
        return cart.loadingFlags.shipMethods;
    }

    get shippingMethods(): ShippingMethod[] {
        return checkout.shippingMethods;
    }

    get countries(): string[] {
        return checkout.countries;
    }

    get totals(): Totals {
        return cart.totals;
    }

    get freethreshold(): number {
        return parseFloat(store.state.options.carrier.freethreshold);
    }

    get giftcardLoading(): boolean {
        return cart.loadingFlags.giftcard;
    }

    get isVirtual(): boolean {
        return cart.isVirtual;
    }

    get isShippingLoading() {
        return checkout.isShippingLoading;
    }

    private isActive(method: ShippingMethod): boolean {
        return this.getKey(method) === this.selectedShipment;
    }

    private getKey(method: ShippingMethod) {
        return encodeShipment(method);
    }

    private showFreeShipping(method: ShippingMethod): boolean {
        return method.method_code === 'owsh1' && this.totals.subtotal < this.freethreshold;
    }

    private calcFreeShipping(): number {
        const val = this.freethreshold - this.totals.subtotal;
        return Vue.filter('currency')(val);
    }
}
